import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {getStatus} from 'src/utils/referral-v2';
import {
  Card,
  CardHeader,
  SubTitleMedium,
  CardContent,
  LinearLoader,
  Icon,
  StatusIndicator,
} from '@spaced-out/ui-design-system/lib/components/index';
import css from 'src/components/referral-v2/tracking/tracking.css';


const ProgressBar = ({currentStatus}: {currentStatus: string}) => {
  const {t} = useLabelTranslation();
  const STATUS = getStatus(t);
  const getStatusValue = () => {
    switch (currentStatus) {
      case STATUS.REFERRED:
        return 20;
      case STATUS.UNDER_REVIEW:
        return 40;
      case STATUS.CONSIDERED:
        return 60;
      case STATUS.HIRED:
        return 80;
      case STATUS.PAID:
        return 100;
      default:
        return 0;
    }
  };

  const currentStageIndex = Object.values(STATUS).indexOf(currentStatus);
  const nextStatus = Object.values(STATUS)[currentStageIndex + 1];

  return (
    <Card classNames={{wrapper: css.sidePandelCard}}>
      <CardHeader>
        <SubTitleMedium>{t('Progress', 'Progress')}</SubTitleMedium>
      </CardHeader>
      <CardContent className={css.progressBar}>
        <LinearLoader size="large" value={getStatusValue()} />
        <div className={css.modalHeaderInfo}>
          {Object.keys(STATUS)
            .filter((status) => status !== 'NOT_CONSIDERED')
            .map((status, index) => {
              if (index <= currentStageIndex) {
                return (
                  <div className={css.actionBar}>
                    <Icon color="success" name="check-circle" />{' '}
                    {/* @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ REFERRED: string; CONSIDERED: string; UNDER_REVIEW: string; HIRED: string; PAID: string; NOT_CONSIDERED: string; }'. */}
                    {STATUS[status]}
                  </div>
                );
              }
              return (
                <div className={css.actionBar}>
                  {/* @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ REFERRED: string; CONSIDERED: string; UNDER_REVIEW: string; HIRED: string; PAID: string; NOT_CONSIDERED: string; }'. */}
                  {STATUS[status] === nextStatus && (
                    <StatusIndicator status={'information'} />
                  )}
                  {/* @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ REFERRED: string; CONSIDERED: string; UNDER_REVIEW: string; HIRED: string; PAID: string; NOT_CONSIDERED: string; }'. */}
                  {STATUS[status]}
                </div>
              );
            })}
        </div>
      </CardContent>
    </Card>
  );
};

export default ProgressBar;
